module.exports = __webpack_public_path__ + "img/item18.828b89b6.png";